import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import { hasEmptyRequiredFields } from "Components/optionForm";
import WithModal from "Components/withModal";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { NEW_DOCUMENT_OBJECT, documentObjectRequiredFields } from "../constants";
import NodeCreator from "./nodeCreator";
import locale from "./nodeCreatorPanel.locale";
export const SIZES = {
    MODAL_DEFAULT_WIDTH: 400,
    MODAL_DEFAULT_HEIGHT: 297,
    MODAL_HEIGHT: 297
};
function NodeCreatorPanel(props) {
    const [changes, setChanges] = useState({});
    const [open, setOpen] = useState(props.open);
    const [showRequiredErrors, setShowRequiredErrors] = useState(false);
    const draft = useMemo(() => ({ ...NEW_DOCUMENT_OBJECT, ...changes }), [changes]);
    const handleResetDraft = useCallback(() => {
        setChanges({});
        setShowRequiredErrors(false);
    }, []);
    useEffect(() => {
        if (props.open) {
            handleResetDraft();
        }
        setOpen(props.open);
    }, [props.open]);
    const handleClose = useCallback(() => {
        props.onClose && props.onClose();
    }, [props.onClose]);
    const handleChangeDraft = useCallback((fieldName, value) => {
        setShowRequiredErrors(false);
        setChanges(prev => value === get(NEW_DOCUMENT_OBJECT, fieldName)
            ? omit(prev, fieldName)
            : {
                ...prev,
                [fieldName]: value
            });
    }, []);
    const handleAdd = useCallback(() => {
        if (hasEmptyRequiredFields(draft, documentObjectRequiredFields)) {
            setShowRequiredErrors(true);
        }
        else if (props.onAdd) {
            props.onAdd(draft);
            props.onClose && props.onClose();
        }
    }, [draft, props.onAdd, props.onClose]);
    return (React.createElement(WithModal, { show: open, onHide: handleClose, contentClassName: "modal-padding", shadingColor: shadingLightestColor, className: "bg-blur", title: locale.CREATE_NODE, defaultWidth: SIZES.MODAL_DEFAULT_WIDTH, defaultHeight: SIZES.MODAL_DEFAULT_HEIGHT, height: SIZES.MODAL_HEIGHT },
        React.createElement(NodeCreator, { draft: draft, onChangeDraft: handleChangeDraft, onResetDraft: handleResetDraft, hasChanges: !isEmpty(changes), showRequired: true, showRequiredErrors: showRequiredErrors, onAdd: props.onAdd ? handleAdd : undefined })));
}
export default memo(NodeCreatorPanel);
